import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';

export const getRegistroRutas = async (idRecolector) => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/rutas?empresa=${userInfo.empresa}&idRecolector=${idRecolector}`);
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const crearRegistroRutas = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        
        const {data}  = await Axios.post(
            '/rutas', clienteData
        );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const updateRegistroRutas = async (clienteData) => {
    try {
        const userInfo = fetchUser();
        clienteData.empresa = userInfo.empresa;
        const {data}  = await Axios.patch(
          `/rutas/${clienteData._id}`, clienteData
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const deleteRegistroRutas = (Id) => Axios.delete(`/rutas/${Id}`);